import React, { useCallback, useState } from "react";
import imagegallery from "../assets/imagegallery.png";
import videogallery from "../assets/videogallery.png";
import inforound from "../assets/inforound.png";
import tick from "../assets/tick.png";
import { useNavigate } from "react-router-dom";
import { useDropzone } from "react-dropzone";
import { useDispatch } from "react-redux";
import {setFourthPage} from "../../store/addBusinessSlice";
function Video() {

  const dispatch = useDispatch();
  let imagesList = [];
  const [imageUrl, setImageUrl] = useState(null);
 
  console.log("img",imageUrl);

  // Following code is used for react dropzone:

  const onDrop = useCallback((acceptedFiles) => {
    console.log("acceptedFiles: ", acceptedFiles[0]);
    imagesList = [...imagesList, acceptedFiles[0]];
    console.log("Accepted File: ", imagesList);

    // console.log("Image URL: ", URL.createObjectURL(acceptedFiles[0]));
    setImageUrl(URL.createObjectURL(acceptedFiles[0]));

    dispatch(setFourthPage({images:acceptedFiles[0]}));
  }, []);
  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const navigate = useNavigate();
  const nextpage = () => {
    navigate("/preview");
  };
  return (
    <>
      <div
        className="d-flex align-items-center ps-3 pe-3 box_height mb-5"
        style={{ height: "100vh", width: "100%" }}
      >
        <div className="container box_div">
          <div className="steper_div">
            <div className="num">
              <img className="tick_img" src={tick} />
            </div>
            <div className="border_bottom_div"></div>
            <div className="num">
              <img className="tick_img" src={tick} />
            </div>
            <div className="border_bottom_div"></div>
            <div className="num">
              <img className="tick_img" src={tick} />
            </div>
            <div className="border_bottom_div"></div>
            <div className="num">
              <p>4</p>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <div className="video_card">
              <p className="business_heading1_main">Add Business Detail</p>
              <p className="video_text">
                Upload up to 5 images
                <span className="video_span">(Min 1 image),</span> a video
                <span className="video_span">(Optional) and a</span> Logo{" "}
                <span className="video_span">
                  (Optional - 400px X 400px) (950px X 720px) Or (1900px X
                  1440px)
                </span>
              </p>
              <div className="d-flex gap-2 flex-wrap justify-content-center mt-4 mb-3">
                <div {...getRootProps()}>
                  <input {...getInputProps()} />
                  {/* <p>Drag 'n' drop some files here, or click to select files</p> */}
                  <img
                    className="gallery_img"
                    src={!imageUrl.length > 0 ? imagegallery : imageUrl}
                  />
                </div>
                {/* <img className="gallery_img" src={imagegallery} /> */}
                <img className="gallery_img" src={videogallery} />
                <img className="gallery_img" src={imagegallery} />
              </div>
              <div className="d-flex gap-2 align-items-center justify-content-center inforound_div">
                <img src={inforound} />
                <p className="heading_inforound">
                  Do not upload any illegal and/or copy written content!
                </p>
              </div>

              <div className="d-flex justify-content-center">
                <button className="done_btn" onClick={nextpage}>
                  DONE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Video;
